// extracted by mini-css-extract-plugin
export default {"stacked":"OrderDateTime_stacked__1OFn-","inline":"OrderDateTime_inline__K6SOq"};